import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import FlareRoundedIcon from '@mui/icons-material/FlareRounded';
import GavelRoundedIcon from '@mui/icons-material/GavelRounded';
import MenuBookRoundedIcon from '@mui/icons-material/MenuBookRounded';
import Button from '@mui/material/Button';
import { useCallback } from 'react';
import { createGetAdminNewestPlayersListOutbound, createGetRecentAdminActionsOutbound } from '../../api/outbound/commonOutbounds';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { addMessageBox } from '../../redux/actions/messageBoxesActions';
import { useAppDispatch } from '../../redux/store';
import { ADMIN_PANEL_CONTENT_BACKGROUND_COLOR } from '../../styles/colors';
import { PANEL_FRAMELESS_CONTENT_PADDING_STRING } from '../../styles/styles';
import { FramelessPanelSection } from '../framelessPanelSection';
import { PanelHeader } from '../panelHeader';
import { PanelItem } from '../panelItem';
import { PanelContainer } from '../panelStyles';
export const AdminPanel = () => {
    const dispatch = useAppDispatch();
    const socketSend = useSocketSend();
    const onClickAdminChatCommands = useCallback(() => {
        dispatch(addMessageBox({ type: 'admin-manual' }));
    }, [dispatch]);
    const onClickNewestPlayers = useCallback(() => {
        socketSend(createGetAdminNewestPlayersListOutbound());
    }, [socketSend]);
    const onClickRecentAdminActions = useCallback(() => {
        socketSend(createGetRecentAdminActionsOutbound());
    }, [socketSend]);
    return (_jsxs(PanelContainer, { padding: PANEL_FRAMELESS_CONTENT_PADDING_STRING, "aria-label": 'admin panel', children: [_jsx(PanelHeader, { title: 'Admin', color: 'white', withPadding: true }), _jsxs(FramelessPanelSection, { backgroundColor: ADMIN_PANEL_CONTENT_BACKGROUND_COLOR, children: [_jsx(PanelItem, { children: _jsx(Button, { onClick: onClickRecentAdminActions, variant: 'contained', color: 'secondary', startIcon: _jsx(GavelRoundedIcon, {}), fullWidth: true, children: "Recent Admin Actions" }) }), _jsx(PanelItem, { children: _jsx(Button, { onClick: onClickNewestPlayers, variant: 'contained', color: 'secondary', startIcon: _jsx(FlareRoundedIcon, {}), fullWidth: true, children: "Newest Players" }) }), _jsx(PanelItem, { children: _jsx(Button, { onClick: onClickAdminChatCommands, variant: 'contained', color: 'secondary', startIcon: _jsx(MenuBookRoundedIcon, {}), fullWidth: true, children: "Admin Manual" }) })] })] }));
};
